// ============================================================================
// Componente: FinanceiroNumerario.js — sub-hub do Numerário
// Objetivo: as duas telas do submódulo (Conferência e Importar relatório).
// Padrão visual: Financeiro / teal (#0d7a74)
//
// Nasceu na Fase 3, junto da segunda tela — na Fase 1 o card do hub apontava
// direto para o importador, porque um sub-hub de uma aba só é um clique que não
// informa nada.
// ============================================================================

import React, { useState } from 'react';
import { Scale, FileUp, CalendarRange, FileSpreadsheet } from 'lucide-react';

import FinanceiroNumerarioConciliacao from './FinanceiroNumerarioConciliacao';
import FinanceiroNumerarioDiario from './FinanceiroNumerarioDiario';
import FinanceiroNumerarioSap from './FinanceiroNumerarioSap';
import FinanceiroNumerarioProsegur from './FinanceiroNumerarioProsegur';

const COR = '#0d7a74';

// Na ordem do trabalho da semana: chega o relatório → importa → olha o dia →
// confere → lança no SAP. As abas seguem a sequência em que a pessoa trabalha,
// não a importância de cada tela.
const ABAS = [
    { id: 'importar', label: 'Importar relatório', icon: FileUp, Componente: FinanceiroNumerarioProsegur },
    { id: 'diario', label: 'Por dia', icon: CalendarRange, Componente: FinanceiroNumerarioDiario },
    { id: 'conciliacao', label: 'Conferência', icon: Scale, Componente: FinanceiroNumerarioConciliacao },
    { id: 'sap', label: 'Lançamento SAP', icon: FileSpreadsheet, Componente: FinanceiroNumerarioSap },
];

const FinanceiroNumerario = () => {
    const [aba, setAba] = useState(ABAS[0].id);
    const Atual = ABAS.find((a) => a.id === aba).Componente;

    return (
        <div>
            <nav style={{
                display: 'flex', gap: 4, borderBottom: '2px solid #e2e8f0', marginBottom: 4,
            }}>
                {ABAS.map(({ id, label, icon: Icone }) => {
                    const ativa = id === aba;
                    return (
                        <button
                            key={id}
                            type="button"
                            onClick={() => setAba(id)}
                            style={{
                                display: 'inline-flex', alignItems: 'center', gap: 8,
                                background: 'none', border: 'none', cursor: 'pointer',
                                padding: '12px 18px', fontSize: 14,
                                fontWeight: ativa ? 700 : 500,
                                color: ativa ? COR : '#64748b',
                                borderBottom: `3px solid ${ativa ? COR : 'transparent'}`,
                                marginBottom: -2,
                            }}
                        >
                            <Icone size={17} /> {label}
                        </button>
                    );
                })}
            </nav>
            <Atual />
        </div>
    );
};

export default FinanceiroNumerario;
